<template>
  <div class="flex flex-col justify-between">
    <div class=" bg-b2c-grey-100 text-black text-center py-6 mb-4">
      <h1 class="w-full px-4
      font-bold tracking-widest uppercase text-md mb-2">
        {{ $t('cards.areYouSure') }}
      </h1>
      <h2>
        ({{ $t('cards.irreversible') }})
      </h2>
    </div>
    <div class="flex flex-row justify-between my-2 text-sm w-1/2 mx-auto mb-10">
        <button
          @click="$emit('close')"
          class="mx-2 py-3 rounded border bg-b2c-red-300 border-b2c-red-300 w-1/2 md:w-full
          hover:bg-white text-white hover:text-b2c-red-300 font-bold cursor-pointer">
            {{ $t('cards.cancel') }}
        </button>
        <button
          @click="deletePaymentMethod()" :class="isLoading ? 'loader' : ''"
          class="mx-2 py-3 rounded border w-1/2 md:w-full bg-b2c-red-300 border-b2c-red-300
          hover:bg-white text-white hover:text-b2c-red-300 font-bold cursor-pointer">
            {{ $t('cards.delete') }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: ['id'],

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      customer: ['auth/customer'],
    }),
  },

  methods: {
    deletePaymentMethod() {
      this.isLoading = true;
      axios.delete(`/api/customers/${this.customer.id}/payment-method?id=${this.id}`).then(() => {
        this.$store.dispatch('cart/deletedPaymentMethod');
        this.$emit('close');
        this.isLoading = false;
      }).catch((error) => {
        this.isLoading = false;
        this.$emit('close');
        this.checkSessionErrorNotification(error);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  color: transparent !important;
  pointer-events: none;
  position: relative;
}

.loader:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #dbdbdb;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  width: 1em;
  height: 1em;
  position: absolute;
  left: calc(50% - (1em / 2));
  top: calc(50% - (1em / 2));
}

@keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
